import { isBrowserIe, isBrouserEdge, isBrowserIOSSafari } from './BrowserJudgment';
import { Content } from './types/Template';
import { fm_types, merge_index, merge_last, merge_year, scroll_option } from './Const';
/**
 * 画面トップへスクロール
 */
export const scrollTop = () => {
  const logo = document.getElementsByClassName('scroll-top')[0];

  logo?.addEventListener('click', event => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  });
};
scrollTop();

/**
 * ナビゲーションバーを考慮し、対象要素までスクロールする
 *
 * @param element 対象要素
 * @param option 対象要素 + α の移動幅
 */
export const scrollTargetElement = (element: HTMLElement | null, option: number) => {
  if (element === null) {
    return;
  }
  // navbarの高さを算出する
  const header = document.getElementById('navbar');
  const header_height = header !== null && typeof header !== 'undefined' ? header.clientHeight : 0;

  // ClientRectを取得する
  const client_rect = element?.getBoundingClientRect();
  // 要素の高さを取得する
  const element_height = typeof client_rect !== 'undefined' ? client_rect.height : 0;
  // 座標を算出する
  const pos_y = typeof client_rect !== 'undefined' ? client_rect.top + window.pageYOffset : 0;

  if (isBrowserIe()) {
    // IE
    // NOTE IEはnavbarが追従してこないため、navbarの高さを考慮しない
    scrollTo(0, pos_y + element_height + option);
  } else if (isBrouserEdge() || isBrowserIOSSafari()) {
    // Edge(従来版), iOS版Safari
    scrollTo(0, pos_y + element_height - header_height + option);
  } else {
    scrollTo({
      top: pos_y + element_height - header_height + option,
      left: 0,
      behavior: 'smooth',
    });
  }
};

/**
 * 画面トップへスクロール
 */
export const scrollPageTop = () => {
  window.scrollTo({ top: 0, left: 0 });
};

/**
 * エラーの対象elementを取得する
 *
 *  @param contents  対象要素
 *  @param index  対象要素のindex番号
 *  @returns 対象element, スクロール調整幅
 */
export const getTargetById = (contents: Content[], index: number) => {
  const target_id =
    contents[index].fm_type === fm_types.radio || contents[index].fm_type === fm_types.radio_desired_econtract || contents[index].fm_type === fm_types.deselect_radio
      ? `${contents[index].key}${merge_index}`
      : contents[index].fm_type === fm_types.name || contents[index].fm_type === fm_types.postcode || contents[index].fm_type === fm_types.sei_name
      ? `${contents[index].key}${merge_last}`
      : contents[index].fm_type === fm_types.year_month || contents[index].fm_type === fm_types.time
      ? `${contents[index].key}${merge_year}`
      : contents[index].key;

  return {
    target_element: document.getElementById(target_id),
    scroll_option: scrollOption(contents, index),
  };
};

/**
 * 対象elementに合わせて座標移動
 *
 * @param target_element  対象要素
 */
export const targetMovePoint = (
  target_element: HTMLElement | null,
  scroll_option: number
): void => {
  window.setTimeout(() => {
    // 対象elementに合わせて座標移動
    scrollTargetElement(target_element, scroll_option);
    target_element?.focus();
  }, 500);
};

/**
 * 対象要素の種別に応じてスクロール幅を調整する
 *
 */
const scrollOption = (contents: Content[], index: number): number => {
  return contents[index].fm_type === fm_types.checkbox ||
    contents[index].fm_type === fm_types.refinance_target_checkbox ||
    contents[index].fm_type === fm_types.guarantor_num_linked_checkbox
    ? scroll_option.validation_checkbox
    : scroll_option.validation;
};
